import { render, staticRenderFns } from "./RouteMark.vue?vue&type=template&id=4f3a8113&scoped=true&"
import script from "./RouteMark.vue?vue&type=script&lang=js&"
export * from "./RouteMark.vue?vue&type=script&lang=js&"
import style0 from "./RouteMark.vue?vue&type=style&index=0&id=4f3a8113&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3a8113",
  null
  
)

export default component.exports